export default "./images/ED55.jpg";